module.exports = __webpack_public_path__ + "img/meja.ee023740.jpg";